import { render, staticRenderFns } from "./ModalPressureSensor.vue?vue&type=template&id=164b3a0f&"
import script from "./ModalPressureSensor.vue?vue&type=script&lang=js&"
export * from "./ModalPressureSensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports